import { getFbPid } from './Adjustscript';
import { nanoid } from 'nanoid';
import qs from 'qs';

const searchChannel = location.search.match(/(&|\?)channel=(\w+)/);
const channel = searchChannel ? searchChannel[2] : '';

export const addScript = () => {
  if (channel === 'fb') {
    addFbPixel();
  }

  if (channel === 'tt') {
    addTTPixel();
  }
  addGoogleAnalytics();
};

export const addFbPixel = () => {
  const script = document.createElement('script');
  script.textContent = `
  !function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '818381046841758');
fbq('track', 'PageView');
  `;
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(script);

  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src =
    'https://www.facebook.com/tr?id=818381046841758&ev=PageView&noscript=1';
  noscript.appendChild(img);
  head.appendChild(noscript);
};

export const setDeviceID = () => {
  const key = 'device-id';
  if (localStorage.getItem(key)) return;
  const id = nanoid();
  localStorage.setItem(key, id);
};
export const addTTPixel = () => {
  const script = document.createElement('script');
  script.textContent = `
  !function (w, d, t) {
    w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
    ttq.load('CO9LOA3C77U6F5DVNT9G');
    ttq.page();
  }(window, document, 'ttq');
  `;
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(script);
};

export const addGoogleAnalytics = () => {
  //
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-4KW9VKD7T9';
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(script);

  const script2 = document.createElement('script');
  script2.textContent = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-4KW9VKD7T9');
  `;
  head.appendChild(script2);
};

export const getDeviceID = () => localStorage.getItem('device-id');

// pageview ，每次今日页面都上报
export const reportPv = () => {
  const id = getDeviceID();
  if (channel === 'fb') {
    window.fbq('track', 'ViewContent', {
      deviceId: id,
      channel: 'fb',
    });
  }
  if (channel === 'tt') {
    window.ttq.track('ViewContent', { deviceId: id, channel: 'tt' });
  }
  // if (channel === 'google') {
  //   ;window.gtag('event', 'ga_view_content', { deviceId: id, channel: 'google' })
  // }
  window.gtag('event', 'ga_view_content', {
    deviceId: id,
    channel: 'google',
  });
};

// 只上报一次
export const reportUv = () => {
  const uvReported = localStorage.getItem('uv-reported');
  if (uvReported) return;
  localStorage.setItem('uv-reported', 'true');
  const id = getDeviceID();
  if (channel === 'fb') {
    window.fbq('track', 'fb_first_visit', {
      deviceId: id,
      channel: 'fb',
    });
  }
  if (channel === 'tt') {
    window.ttq.track('tt_first_visit', {
      deviceId: id,
      channel: 'tt',
    });
  }
  // if (channel === 'google') {
  //   ;window.gtag('event', 'ga_first_visit', { deviceId: id, channel: 'google' })
  // }
  window.gtag('event', 'ga_first_visit', {
    deviceId: id,
    channel: 'google',
  });
};

// 每次点击下载按钮都上报
export const reportClickDownloadEvery = () => {
  if (channel === 'fb') {
    window.fbq('trackCustom', 'SubmitApplication', {
      deviceId: getDeviceID(),
    });
  }
  if (channel === 'tt') {
    window.ttq.track('ClickButton', { deviceId: getDeviceID() });
  }
  // if (channel === 'google') {
  //   ;window.gtag('event', 'ga_clickbutton', { deviceId: getDeviceID() })
  // }
  window.gtag('event', 'ga_clickbutton', { deviceId: getDeviceID() });
};

// 点击下载按钮只上报一次
export const reportClickDownloadOnce = () => {
  //
  const key = 'download-reported';
  if (localStorage.getItem(key)) return;
  localStorage.setItem(key, 'true');
  if (channel === 'fb') {
    window.fbq('trackCustom', 'fb_first_clickbutton', {
      deviceId: getDeviceID(),
      channel: 'fb',
    });
  }
  if (channel === 'tt') {
    window.ttq.track('tt_first_clickbutton', {
      deviceId: getDeviceID(),
      channel: 'tt',
    });
  }
  window.gtag('event', 'ga_first_clickbutton', {
    deviceId: getDeviceID(),
    channel: 'google',
  });
};

// 下载成功，只上报一次
export const reportDownloadSuccess = () => {
  //
  const key = 'download-success-reported';
  if (localStorage.getItem(key)) return;
  localStorage.setItem(key, 'true');
  if (channel === 'fb') {
    window.fbq('track', 'StartTrial', {
      deviceId: getDeviceID(),
      channel: 'fb',
    });
  }
  if (channel === 'tt') {
    window.ttq.track('Download', {
      deviceId: getDeviceID(),
      channel: 'tt',
    });
  }
  // if (channel === 'google') {
  //   ;window.gtag('event', 'ga_download', {
  //     deviceId: getDeviceID(),
  //     channel: 'google',
  //   })
  // }
  window.gtag('event', 'ga_download', {
    deviceId: getDeviceID(),
    channel: 'google',
  });
};

// Facebook 接入了 Adjust，点击下载后，需要调用 adjust 的链接
export const fbDownload = (type) => {
  const campaign = getArgsFromUrl('p1') || '';
  const campaignId = getArgsFromUrl('p2') || '';
  const adsetName = getArgsFromUrl('p3') || '';
  const adsetId = getArgsFromUrl('p4') || '';
  const adName = getArgsFromUrl('p5') || '';
  const adId = getArgsFromUrl('p6') || '';
  const fbclid = getArgsFromUrl('fbclid') || '';
  const fbpid = getFbPid() || '';

  const tracker_token = '1cbxnd5t';
  const redirect =
    type === 'andriod'
      ? 'https://app.goldenjogos.com/offical/goldenjogos_free.apk'
      : '//apps.apple.com/br/app/golden-jogos/id6465079375?l=pt-br';
  const idTokenList = [
    {
      id: '818381046841758',
      token:
        'EAAL1oz2Y6VgBOyn26piJnIaV0GakaJdSPk7j6ZBTvVUbVzSQjIsFa33crmkb78yMlgpBBnZCoZClJPiiBKf4cwB6pLAdKi2xdQQz13ZCxeOz3cpDJlx240QWG1dOH8iiVyvyVSZBgWG2dZAQxxIx7w6kHp0CibCvv3MpF8rZBjAyZBOmYhs3iEWyXSkNYBOIGTrF5QZDZD',
    },
  ];
  const curId = idTokenList[0].id;
  const curToken = idTokenList[0].token;
  let newURL = `https://app.adjust.com/${tracker_token}?campaign=${campaign} (${campaignId})&adgroup=${adsetName} (${adsetId})&creative=${adName} (${adId})&fbclid=${fbclid}&fbpid=${fbpid}&redirect=${redirect}&fb_pixel_id=${curId}&fb_access_token=${curToken}`;
  window.location.href = newURL;
};

export const getAllArgs = () =>
  qs.parse(window.location.search, { ignoreQueryPrefix: true });

export const originGetArgsFromUrl = (key) => {
  const obj = getAllArgs();
  return obj[key] ? obj[key] : null;
};

// 根据key获取url参数的值
export const getArgsFromUrl = (key) => {
  return getArgsFromUrlHash(key);
};

export function getArgsFromUrlHash(key) {
  if (window.location.hash.indexOf('?') !== -1) {
    const obj = qs.parse(window.location.hash.split('?')[1], {
      ignoreQueryPrefix: true,
    });
    return obj[key] ? obj[key] : originGetArgsFromUrl(key);
  }
  return originGetArgsFromUrl(key);
}
